import React from "react";
import ServiceTemplate from "../../components/templates/ServiceTemplate";
import pensionBg from "../../assets/images/produtos/previdencia.webp";

const PrivatePension = () => {
  const serviceData = {
    heroImage: pensionBg,
    title: "Previdência Privada",
    artigo: "uma",
    subtitle:
      "Planeje seu futuro financeiro com soluções personalizadas para sua aposentadoria",
    color: "indigo",
    icon: "piggy-bank",
    ramo: "Previdencia",
    pageRamo: true,
    showEmail: true,
    showVeiculo: false,
    formUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLScQc-SPygWVNQn0Zl1IUIqvtMl73Xa1sa_6qW7IaBalG3J5Ug/formResponse",
    mainContent: [
      "A previdência privada é uma excelente alternativa para complementar sua aposentadoria e garantir qualidade de vida no futuro. Com um plano de previdência da Free Market Seguros, você pode planejar seu futuro financeiro de forma segura e personalizada.",
      "Trabalhamos com as principais instituições financeiras do mercado para oferecer a você as melhores opções de planos, com diferentes perfis de investimento e benefícios fiscais, garantindo a solução ideal para seus objetivos de longo prazo.",
    ],
    coverages: [
      "Renda mensal vitalícia",
      "Renda mensal por prazo determinado",
      "Renda mensal reversível ao cônjuge",
      "Pecúlio por morte",
      "Resgate total ou parcial",
    ],
    additionalCoverages: [
      "Cobertura por invalidez",
      "Isenção de contribuição em caso de incapacidade",
      "Portabilidade entre planos",
      "Benefícios fiscais no Imposto de Renda",
      "Opções de investimento diversificadas",
    ],
    advantages: [
      {
        icon: "chart-line",
        title: "Planejamento Financeiro",
        description:
          "Construção de patrimônio para garantir qualidade de vida na aposentadoria",
      },
      {
        icon: "file-invoice-dollar",
        title: "Benefícios Fiscais",
        description:
          "Possibilidade de dedução das contribuições na declaração do Imposto de Renda",
      },
      {
        icon: "sliders-h",
        title: "Flexibilidade",
        description:
          "Opções de planos e investimentos adaptados ao seu perfil e objetivos",
      },
    ],
    steps: [
      {
        title: "Análise de Perfil",
        description:
          "Avaliamos seu perfil financeiro, objetivos de aposentadoria e tolerância a riscos.",
      },
      {
        title: "Planejamento Personalizado",
        description:
          "Elaboramos um plano personalizado com as melhores opções de previdência para seu perfil.",
      },
      {
        title: "Contratação Simplificada",
        description:
          "Após escolher o plano ideal, cuidamos de toda a documentação e processo de contratação.",
      },
      {
        title: "Acompanhamento Contínuo",
        description:
          "Oferecemos suporte e revisões periódicas para garantir que seu plano continue alinhado aos seus objetivos.",
      },
    ],
    tip: "Escolher um plano de previdência privada vai além da rentabilidade. Entender como o plano se encaixa nos seus objetivos, qual regime de tributação é mais vantajoso e como ele é estruturado pode fazer toda a diferença no longo prazo. Conte com a gente para encontrar a opção ideal para o seu perfil.",
  };

  return <ServiceTemplate {...serviceData} />;
};

export default PrivatePension;
